import type { IntlShape } from "@formatjs/intl";
import type { Dispatch } from "@reduxjs/toolkit";
import { Button, Form, Skeleton } from "antd";
import type { Dayjs } from "dayjs";
import { connect } from "react-redux";
import { actions as routerActions } from "redux-router5";
import ConnectedAppLayout from "../AppLayout";
import type { RootState } from "../store";
import ModalFooter from "../../common/components/ModalFooter";
import { PageTitleContainer } from "../../common/components/PageTitle";
import { routeNames } from "../common/routes";
import { projectActions } from "../../features/project/projectSlice";
import type { Client } from "../generated-axios-client";
import { ProjectFields } from "./ProjectFields";

type NewProjectPageProps = {
	dispatch: Dispatch;
	intl: IntlShape;
	clientItems: Client[];
};

export const NewProjectPage = ({
	dispatch,
	intl,
	clientItems,
}: NewProjectPageProps) => {
	const [form] = Form.useForm();

	if (!clientItems) {
		return <Skeleton active />;
	}

	const save = () => {
		form
			.validateFields()
			.then((values) => {
				dispatch(
					projectActions.addOrUpdateProject({
						...values,
						start: (values.start as Dayjs | null)?.format("YYYY-MM-DD") ?? null,
						end: (values.end as Dayjs | null)?.format("YYYY-MM-DD") ?? null,
					}),
				);
			})
			.catch(() => {});
	};

	return (
		<ConnectedAppLayout>
			<PageTitleContainer
				title={intl.formatMessage({ id: "project_create_title" })}
				subtitle={intl.formatMessage({ id: "project_create_subtitle" })}
			>
				<Form form={form} layout="vertical">
					<ProjectFields intl={intl} clientItems={clientItems} />
				</Form>
				<ModalFooter>
					<Button
						onClick={() =>
							dispatch(routerActions.navigateTo(routeNames.PROJECT_LIST))
						}
					>
						{intl.formatMessage({ id: "ticket_button_title_cancel" })}
					</Button>
					<Button type="primary" onClick={save}>
						{intl.formatMessage({ id: "ticket_button_title_create" })}
					</Button>
				</ModalFooter>
			</PageTitleContainer>
		</ConnectedAppLayout>
	);
};

export const ConnectedNewProjectPage = connect((state: RootState) => ({
	intl: state.intl.datetimeIntl,
	clientItems: state.project.clients,
}))(NewProjectPage);

export default ConnectedNewProjectPage;
